import { AxiosResponseHeaders } from 'axios';
import {
  TransactionsWithDealerRateServiceBody,
  TransactionWithDealerRateResponseDTO,
} from '../../entities/TransactionWithDealerRate/TransactionWithDealerRateResponseDTO';
import { TransactionWithDealerRate } from '../../entities/TransactionWithDealerRate';

const TransactionWithDealerRateResponseDTOtoTransactionsWithDealerRateResponseAdapter = (
  response: TransactionWithDealerRateResponseDTO,
  headers?: AxiosResponseHeaders,
): TransactionsWithDealerRateServiceBody => {
  if (!response.body) {
    throw Error();
  }

  return {
    globalOrders: response.body.globalOrders.map(
      ({
        customerId,
        customerDigit,
        customerSurname,
        system,
        accountNumber,
        accountCode,
        currencyId,
        currencyShortDescription,
        routeGenericDetailDescription,
        routeGenericDetailShortDescription,
        routeGenericDetailParameterType,
        routeGenericDetailSerialNum,
        orderId,
        orderCode,
        orderTrxDate,
        orderDirection,
        orderAmount,
        orderMessageType,
        beneficiaryName,
        beneficiaryAccount,
        beneficiaryIsoCountry,
        beneficiaryBic,
        beneficiarySortCode,
        orderComments,
        externalIdRef,
        processType,
        correspondingAccount,
        correspondingCustomerId,
        trxUser,
        trxUnit,
        timestamp,
        orderLogicalKey,
        financialDate,
        routingResultDescription,
        orderValueDate,
        processingStatus,
        systemDate,
        transferDate,
        beneficiaryBank,
        status,
      }) =>
        new TransactionWithDealerRate(
          customerId,
          customerDigit,
          customerSurname,
          system,
          accountNumber,
          accountCode,
          currencyId,
          currencyShortDescription,
          routeGenericDetailDescription,
          routeGenericDetailShortDescription,
          routeGenericDetailParameterType,
          routeGenericDetailSerialNum,
          orderId,
          orderCode,
          orderTrxDate,
          orderDirection,
          orderAmount,
          orderMessageType,
          beneficiaryName,
          beneficiaryAccount,
          beneficiaryIsoCountry,
          beneficiaryBic,
          beneficiarySortCode,
          orderComments,
          externalIdRef,
          processType,
          correspondingAccount,
          correspondingCustomerId,
          trxUser,
          trxUnit,
          timestamp,
          orderLogicalKey,
          financialDate,
          routingResultDescription,
          orderValueDate,
          processingStatus,
          systemDate,
          transferDate,
          beneficiaryBank,
          status,
        ),
    ),
    paginationTotal: response.body.paginationTotal,
  };
};

export { TransactionWithDealerRateResponseDTOtoTransactionsWithDealerRateResponseAdapter };
